import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const ContactUs = () => {
  const form = useRef();
  const [isMessageSent, setIsMessageSent] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();

    try {
      await emailjs.sendForm('service_jyxz8ue', 'template_v8nw2ek', form.current, '3gIyFAu7beYJEJHV5');
      setIsMessageSent(true);
    } catch (error) {
      console.error('Error sending email:', error);
    }
  };

  return (
    <section className="contact">
      <div className="contact-form">
        <h2>Send Message</h2>
        {isMessageSent ? (
          <p className="success-message">Message sent successfully!</p>
        ) : (
          <form ref={form} onSubmit={sendEmail}>
            <input name="to_name" type="text" placeholder="Your Name" />
            <input name="from_name" type="email" placeholder="Your Email" />
            <textarea name="message" placeholder="Your Message"></textarea>
            <button className="c-btn" type="submit">
              Send Message
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default ContactUs;


